import {ContentClient} from '@/clients/ContentClient';
import {defineStore} from 'pinia'

export const useContentStore = defineStore('content', {
    state: () => ({
        content: [],
        stat: []
    }),
    getters: {
        userContent(state) {
            return state.content;
        },
        userStat(state) {
            return state.stat;
        },
    },
    actions: {
        async getUserContent() {
            let response = await ContentClient.getUserContent();
            this.content = response.data.list;
            this.stat = response.data.stat;
        },

        async getLink(id) {
            let response = await ContentClient.getQuestLink(id);
            return response.data;
        },
    },
})
